
export enum AddressType {
    Permanent = <any>'Permanent',
    Correspondence = <any>'Correspondence',
}

export enum LiveWith {
    NoOne = <any>'NoOne',
    Friends = <any>'Friends',
    Family = <any>'Family'
}
export enum PersonalDetailsSource {
    Customer = <any>'Customer',
    Aadhaar = <any>'Aadhaar'
}

export enum Gender {
    Male = <any>'Male',
    Female = <any>'Female',
    Others = <any>'Others'
}
